module.exports = __webpack_public_path__ + "img/image 7.77d7e55f.png";